export default function LocaleService(
    $window,
    sessionService
) {
    'ngInject';

            const DEFAULT_CULTURE = 'en-GB';
            const ENGLISH_LOCALE = 'en';
            const DEFAULT_COUNTRY_CODE = 'uk';

            return {
                setWorkWeekByCulture,
                getCurrentCulture,
                getDefaultCountryCode,
            };

            function setWorkWeekByCulture(culture) {
                $window.moment.locale(ENGLISH_LOCALE, {
                    week: {
                        dow: isEnglish(culture),
                        doy: 4,
                    },
                });
            }

            function isEnglish(culture) {
                return DEFAULT_CULTURE === culture;
            }

            function getCurrentCulture() {
                const services = sessionService.getSessionItem('availableServices');
                if (services) {
                    return services.RegionalSettings.Culture;
                }
                return DEFAULT_CULTURE;
            }

            function getDefaultCountryCode() {
                return DEFAULT_COUNTRY_CODE;
            }
}



// WEBPACK FOOTER //
// ./src/app/services/locale-service.js